/**
 * from:
 * { 'key': 'value' }
 * 
 * to:
 * [
 *   { value: 'key', label: 'value' },
 * ]
 */
export function mapToList(obj) {
  return Object.entries(obj)
    .map(([value, label]) => ({ value, label }))
}